"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgArrowRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M5.333 16h21.334m0 0-8-8m8 8-8 8" }))); };
exports.default = SvgArrowRight;
//# sourceMappingURL=ArrowRight.js.map